var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 000 "),_c('span',{staticClass:"demonstration"},[_vm._v("折叠展示Tag")]),_c('el-cascader',{attrs:{"options":_vm.options,"props":_vm.props,"collapse-tags":"","clearable":""},model:{value:(_vm.tableData.serIds),callback:function ($$v) {_vm.$set(_vm.tableData, "serIds", $$v)},expression:"tableData.serIds"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }